import React from 'react'
import { TabPane, Button, Input } from 'reactstrap'
import { GoalAccordion } from './GoalAccordion'
import './GoalTabPane.css'

const GoalTabPane = ({
	tabId,
	goals,
	goalType,
	selectedRegisterDate,
	onRegisterDateChange,
	onUpdateRegisterDate,
	updateRegisterDatePending,
	onGoalUpdate,
	onActivityUpdate,
	onAddActivity,
	onDeleteGoal,
	onRemoveActivity,
	onAddNewGoal
}) => {
	return (
		<TabPane tabId={tabId}>
			<div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
				<Button color="primary" onClick={() => onAddNewGoal(goalType)}>
					Add New Goal
				</Button>
				<div className="d-flex align-items-center flex-wrap gap-2">
					<label
						htmlFor={`register-date-picker-${tabId}`}
						className="btn btn-outline-secondary register-date-btn mb-1 p-2 d-flex align-items-center gap-2"
						style={{ cursor: 'pointer' }}
					>
						<span>Register Date:</span>
						<Input
							id={`register-date-picker-${tabId}`}
							type="date"
							value={selectedRegisterDate || ''}
							onChange={(e) => onRegisterDateChange(e.target.value)}
							className="border-0 bg-transparent p-0 register-date-input"
							style={{ maxWidth: '150px', cursor: 'pointer' }}
						/>
					</label>
					<Button color="secondary" onClick={onUpdateRegisterDate} disabled={updateRegisterDatePending}>
						{updateRegisterDatePending ? 'Saving…' : 'Update Date'}
					</Button>
				</div>
			</div>
			<GoalAccordion
				goals={goals}
				goalType={goalType}
				onGoalUpdate={onGoalUpdate}
				onActivityUpdate={onActivityUpdate}
				onAddActivity={onAddActivity}
				onDeleteGoal={onDeleteGoal}
				onRemoveActivity={onRemoveActivity}
			/>
		</TabPane>
	)
}

export { GoalTabPane }
